import clsx from 'clsx'

import style from './ChooseActionsLabel.module.css'

type ChooseActionsLabelProps = {
  className?: string
  'aria-hidden'?: boolean
}

export function ChooseActionsLabel({ className, 'aria-hidden': ariaHidden }: ChooseActionsLabelProps) {
  return (
    <span className={clsx(style.root, className)} aria-hidden={ariaHidden}>
      Choose
      <br />
      actions
    </span>
  )
}
